import React from 'react';
import PlayCircleFilledOutlinedIcon from '@mui/icons-material/PlayCircleFilledOutlined';
import { SPACE_RESUME_BUTTON_ICON_SIZE_PX } from './spaceWidgetConstants';

/** Figma: PlayCircleFilledOutlined — 20×20, filled circle with play cutout. */
const SpaceResumePlayIcon = () => (
  <PlayCircleFilledOutlinedIcon
    aria-hidden
    sx={{
      width: SPACE_RESUME_BUTTON_ICON_SIZE_PX,
      height: SPACE_RESUME_BUTTON_ICON_SIZE_PX,
      fontSize: SPACE_RESUME_BUTTON_ICON_SIZE_PX,
      display: 'block',
      flexShrink: 0,
    }}
  />
);

export default SpaceResumePlayIcon;
